import { CartAddEvent } from '@theme/events';

class CartUpsellComponent extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    const button = event.target.closest('[data-upsell-add]');
    if (!button || !this.contains(button)) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.disabled || button.classList.contains('is-adding')) return;

    const variantId = button.getAttribute('data-upsell-add');
    if (!variantId) return;

    const card = button.closest('.cart-upsell__card');
    const cartAddUrl = window.Theme?.routes?.cart_add_url || '/cart/add.js';

    button.disabled = true;
    button.classList.add('is-adding');
    card?.classList.add('is-adding');

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          button.disabled = false;
          button.classList.remove('is-adding');
          card?.classList.remove('is-adding');
          return;
        }

        button.classList.remove('is-adding');
        button.classList.add('is-added');

        this.dispatchEvent(
          new CartAddEvent({}, String(variantId), {
            source: 'cart-upsell',
            itemCount: 1,
            productId: button.dataset.productId,
            variantId: String(variantId),
          })
        );
      })
      .catch((error) => {
        console.error('[cart-upsell]', error);
        button.disabled = false;
        button.classList.remove('is-adding');
        card?.classList.remove('is-adding');
      });
  };
}

if (!customElements.get('cart-upsell-component')) {
  customElements.define('cart-upsell-component', CartUpsellComponent);
}
